import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandler, HandleError } from './http-error-handler.service';
import { DateTimeFormatPipe } from '../pipes/date-time-format.pipe';
import { LoggedInInfo, UserInfo, AuthenticationResult, UsersList } from '../model/login.model';
import { environment } from 'mds-ui/environments/environment';

@Injectable()
export class LoginService {
  state: string;
  nonce: any;
  private handleError: HandleError;
  dtformat = new DateTimeFormatPipe("en-US");
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      "Cache-Control": "no-cache",
      Pragma: "no-cache"
    })
  };
  loggedInInfo: LoggedInInfo;
  userInfo: UserInfo;
  authorityCode: string;

  constructor(private _http: HttpClient,
    httpErrorHandler: HttpErrorHandler) {
    if (!window.location.hash) {
      this.state = this.createNonce();
      this.nonce = this.createNonce(); //this.state 
      sessionStorage[this.state] = this.nonce;

    }
    this.handleError = httpErrorHandler.createHandleError('LoginService');
  }
  userInit() {
    this.userInfo = new UserInfo();
  }
  loggedInInfoInit() {
    this.loggedInInfo = new LoggedInInfo();

  }
  toAuthneticationProcess(response: any): LoggedInInfo {
    this.loggedInInfoInit();
    let da = response.data as any;
    this.userInit();
    this.userInfo.givenName = da.userInfo.givenName + " " + da.userInfo.familyName;
    this.loggedInInfo.userName = da.userInfo.givenName + " " + da.userInfo.familyName;
    this.loggedInInfo.authorityCode = this.authorityCode;
    this.loggedInInfo.isAuthenticated = true;
    this.loggedInInfo.accessToken = da.accessToken;
    this.loggedInInfo.displayableId = da.userInfo.displayableId;
    this.loggedInInfo.expiresOn = new Date(da.expiresOn);
    this.loggedInInfo.homeAccountId = da.userInfo.homeAccountId;
    sessionStorage.setItem('userToken', da.userInfo.givenName + " " + da.userInfo.familyName);
    return this.loggedInInfo;
  }
  //get Users List
  getUsers(accessToken: string, name: string, userName: string, app: string): Observable<any> {
    if (name === undefined || name == null || name === "") {
      name = "";
    }
    if (userName === undefined || userName == null || userName === "") {
      userName = "";
    }
    return this._http.get<any>(
      environment.AuthServiceURL + "users?accessToken=" + accessToken + "&name=" + name + "&userName=" +
      userName + "&app=" + app + "&dateParam=" + this.dtformat.transform(new Date, ""),
      this.httpOptions)
      .pipe(
        catchError(this.handleError<any>('getUsers',[]))
      );
  }
  //get Access Token
  getAccessToken(authority: string, app: string): Observable<AuthenticationResult[]> {
    return this._http.get<AuthenticationResult[]>(
      environment.AuthServiceURL + "aad?authority=" + authority +
      "&urlPath=" + environment.ApplicationURI + "&app=" + app + "&dateParam="
      + this.dtformat.transform(new Date, ""),
      this.httpOptions)
      .pipe(
        catchError(this.handleError<AuthenticationResult[]>('getAccessToken',[]))
      );
  }
  //get Access Token
  getRefreshAccessToken(accountId: string, app: string): Observable<AuthenticationResult[]> {
    return this._http.get<AuthenticationResult[]>(
      environment.AuthServiceURL + "auth/token/refresh?accountId=" + accountId +"&app=" + app + "&dateParam="+ this.dtformat.transform(new Date, ""),
      this.httpOptions)
      .pipe(
        catchError(err => this.handleError('getAccessToken', err))
      );
  }
  //get AccessToken and user
  getAccessTokenAndUser(authority: string, sessionState: string, urlStr: string, appName: string): Observable<AuthenticationResult[]> {
    return this._http.get<AuthenticationResult[]>(
      environment.AuthServiceURL + "aad?authority=" + authority + "&sessionState=" + sessionState +
      "&urlPath=" + urlStr + "&app=" + appName + "&dateParam=" +
      this.dtformat.transform(new Date, ""), this.httpOptions)
      .pipe(
        catchError(err => this.handleError('getAccessTokenAndUser', err))
      );
  }
  public getSignInEndpoint(appName): string {
    console.log("appName", sessionStorage.getItem("appName"));    
    let endpoint = "https://login.microsoftonline.com/" + environment.tenantId + "/oauth2/v2.0/authorize?"
      + "client_id=" + environment.clientId +
      "&response_type=code" +
      "&redirect_uri=" + environment.ApplicationURI +
      "&response_mode=query" +
      "&scope=https://graph.microsoft.com/.default" + "&state=" + this.state;
    return endpoint;
  }
  public getLogOutEndpoint(): string {
    sessionStorage.removeItem('userToken');
    let endpoint =
      "https://login.microsoftonline.com/" + environment.tenantId + "/oauth2/logout?" +
      "post_logout_redirect_uri=" + environment.ApplicationURI;
    return endpoint;
  }
  private createNonce(): string {
    let nonce = "";
    let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i: number = 0; i < 32; i++) {
      nonce += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return nonce;
  }
}
